'use strict';

/*global services*/
/*global createObjectCallBack*/
/*global isEmpty*/

(function ($) {

  function KeyboardController($input, options) {
    this.options = options;
    this.$input = $input;

    this.title = null;
    this.keyboard = null;
    this.modal = null;

    this.init();
  }

  KeyboardController.prototype = $.extend({}, {
    constructor: 'KeyboardController',

    registerCallbacks: function registerCallbacks() {
      var _this = this;

      _this.$input.on('focus', function () {
        if (_this.options.openAfterFocus) {
          _this.open();
        }

        return false;
      });

      _this.$input.next('.k2-keyboard-input__btn--open').on('click', function () {
        _this.open();
        return false;
      });
    },

    //--------------------------------------------------------------------------

    enter: function () {
      var _this = this;

      var value = _this.keyboard.getValue();

      _this.modal.close(function () {
        _this.$input.val(value);
        _this.$input.change();
      });

      return _this;
    },

    open: function open() {
      var _this = this;

      _this.modal.empty().open({
        title: _this.title,
        saveBtnTitle: services.get('translator').trans('form.insert'),
        height: 'auto',
        width: 'md',
        submitCallBack: createObjectCallBack(_this, 'enter'),
        enterSubmitCallBack: createObjectCallBack(_this, 'enter'),
        form: true,
        keyboardClose: false,
        content: '<div class="keyboard-wrapper"></div>'
      });

      _this.modal.contentDOM().find('.keyboard-wrapper').append(_this.keyboard.getKeyboard());

      var placeholder = '';
      if (_this.options.fillInPlaceholder) {
        placeholder = _this.title;

        if (!isEmpty(_this.$input.val())) {
          placeholder = _this.$input.val();
        }
      }

      _this.keyboard.reset();
      _this.keyboard.setLayout(_this.options.layout, _this.options.allowedSwitchLayout);
      _this.keyboard.setPlaceholder(placeholder);
      _this.keyboard.addCustomButtons(_this.options.customButtons);
      _this.keyboard.setVirtualFocus();

      if (_this.options.enabledSpace) {
        _this.keyboard.enableSpaceBtn();
      }

      if (_this.suffix) {
        _this.keyboard.setInputSuffix(_this.suffix);
      }

      return _this;
    },

    //--------------------------------------------------------------------------

    createOpenButton: function createOpenButton() {
      var _this = this;

      //nejdrive obalime input wrapperem
      _this.$input.wrap('<div class="k2-keyboard-input__wrapper"></div>');

      //pak pridame tlacitko
      var $btn = $('<a class="btn btn-info k2-keyboard-input__btn--open" href="#" tabindex="-1"><span class="glyphicon glyphicon-equalizer"></span></a>');
      $btn.insertAfter(_this.$input);

      return _this;
    },

    init: function () {
      var _this = this;

      _this.title = _this.$input.attr('placeholder');
      _this.suffix = _this.$input.next('.input-group-addon').find('.value-suffix').text();
      _this.keyboard = services.get('keyboard');
      _this.modal = services.get('modal-keyboard');
      if (!_this.options.openAfterFocus) {
        _this.createOpenButton();
      }

      _this.registerCallbacks();

      return _this;
    }
  });

  var methods = {
    init: function (options) {
      // options are not used
      var opts = $.extend({}, $.fn.k2_keyboard_input.defaults, options);

      return this.each(function () {
        var $this = $(this);

        if ($this.hasClass('keyboard-init')) {
          return;
        }

        if ($this.attr('readonly')) {
          return;
        }

        $this.addClass('keyboard-init');
        $this.data('keyboard', new KeyboardController($this, opts));
      });
    }
  };

  $.fn.k2_keyboard_input = function (methodOrOptions) {
    if (methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + methodOrOptions + ' does not exists on jQuery.k2_keyboard_input');
    }

  };

  $.fn.k2_keyboard_input.defaults = {
    openAfterFocus: true,
    layout: 'numeric',
    allowedSwitchLayout: true,
    fillInPlaceholder: true,
    enabledSpace: false,
    customButtons: {}
  };

})(jQuery);
